const firebaseConfig = {
  apiKey: "AIzaSyBGghhZtbC4B0qozl0LM-D0d5GktbP7tqg",
  authDomain: "tourism-54098.firebaseapp.com",
  projectId: "tourism-54098",
  storageBucket: "tourism-54098.appspot.com",
  messagingSenderId: "32492606701",
  appId: "1:32492606701:web:f17b8a9d2dc69b296368e4"
};

export default firebaseConfig;